import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { GRADE_CONFIG } from './gradeConfig';

interface GradeChipProps {
	/** API grade value (e.g. 'extreme', 'high', ...). */
	grade: string;
	/** Optional style overrides merged onto the base chip styling. */
	sx?: SxProps<Theme>;
}

/**
 * Pill-shaped grade badge shared by the asset results grid and the asset curve dialog.
 * Renders nothing when the grade has no matching config.
 */
export const GradeChip = ({ grade, sx }: GradeChipProps): JSX.Element | null => {
	const cfg = GRADE_CONFIG[grade];
	if (!cfg) return null;

	return (
		<Box
			sx={{
				display: 'inline-flex',
				alignItems: 'center',
				px: '10px',
				py: '2px',
				borderRadius: '9999px',
				fontSize: '0.6875rem',
				fontWeight: 700,
				letterSpacing: '0.05em',
				color: cfg.color,
				background: cfg.bg,
				border: `1px solid ${cfg.color}33`,
				whiteSpace: 'nowrap',
				...sx,
			}}>
			{cfg.label}
		</Box>
	);
};
